// Module
var code = "<react-component name=\"BulkAddMemberships\"></react-component>\n";
// Exports
module.exports = code;